import { TutorialCategoryEnum } from '@/apis/cms';

namespace AltContents {
  export const ToSResponse = {
    contents: [
      {
        id: 'alttos',
        createdAt: new Date('2020-04-06T09:50:31.452Z'),
        updatedAt: new Date('2021-09-01T02:21:08.756Z'),
        title: '利用規約',
        order: 1,
        body:
          '<h2 style="text-align:center">MONET マーケットプレイス利用規約</h2><p><br>MONET Technologies株式会社（以下、「当社」といいます。）は、当社が提供するMONET マーケットプレイス（以下、「本サービス」といいます。）の会員登録について利用規約（以下、「本利用規約」といいます。）を定めます。本サービスを利用するためには、本利用規約の全てに同意して会員登録の申込を行っていただく必要があり、会員登録の申込を行った場合、本利用規約に同意したものとみなされるものとします。<br><br>本利用規約の詳細については、別途当社から直接案内を送らせていただきますので、<a href="https://www.monet-technologies.com/inquiries#no-back" target="_blank" rel="noopener noreferrer">こちら</a>からお問い合わせください。<br></p>'
      }
    ]
  };
  export const DocsResponse = {
    contents: [
      {
        id: 'altdocs',
        createdAt: new Date('2020-09-09T04:47:53.231Z'),
        updatedAt: new Date('2021-05-19T01:37:05.478Z'),
        publishedAt: '2020-09-09T04:47:53.231Z',
        section: ['概要'],
        order: 1,
        title: 'MONETマーケットプレイスとは',
        body: [
          {
            fieldId: 'paragraph',
            body:
              '<p>本サイトでは、MONETのMaaSビジネスで実際に使っているAPIを提供します。<br><br> 各APIの詳細やMONETマーケットプレイスの不明点など、ご気軽に<a href="https://www.monet-technologies.com/inquiries#no-back" target="_blank" rel="noopener noreferrer">こちら</a>からお問い合わせください。'
          }
        ]
      }
    ]
  };
  export const NoticeResponse = {
    id: 'altnotice',
    createdAt: new Date('2020-09-09T04:47:53.231Z'),
    updatedAt: new Date('2021-05-19T01:37:05.478Z'),
    content:
      '現在システムメンテナンス中です。ご迷惑おかけしますが、しばらくたってから再度ご利用ください。'
  };
  export const Notice404Response = {
    id: 'altnotice',
    createdAt: new Date('2020-09-09T04:47:53.231Z'),
    updatedAt: new Date('2021-05-19T01:37:05.478Z'),
    content: ''
  };
  export const TutorialsResponse = {
    contents: [
      {
        id: 'alttutorial',
        createdAt: new Date('2021-04-15T00:45:45.706Z'),
        updatedAt: new Date('2021-05-06T04:19:40.883Z'),
        title: 'チュートリアル全般について',
        overview:
          '<p>本チュートリアルページでは、MONETマーケットプレイスの各プロダクトの利用方法や活用例を提供します。<br>注意点として、以下の項目に御留意ください。<br></p><ul><li>開発に際して、詳しいライブラリのリファレンスなどは適宜別途資料を参照してください。</li><li>以降抜粋したコードのなかで定義されていない変数などは、適宜適切な部分で定義してください。</li><li>記載のコードにはエラーハンドリングなどが不足している場合もあり、実際に使う場合には注意が必要です。</li></ul><p><br>その他、それぞれのチュートリアル内で示された、プロダクト特有の注意点についても十分にご理解の上参照してください。</p>',
        category: ['利用マニュアル'] as TutorialCategoryEnum[],
        products: [],
        steps: []
      }
    ]
  };
}

export { AltContents };
